// extracted by mini-css-extract-plugin
module.exports = {"playHeight":"styles_playHeight___asHO","logo":"styles_logo__ogqxz"};